import { render, staticRenderFns } from "./iconMsg.vue?vue&type=template&id=123dd42a&scoped=true&"
import script from "./iconMsg.vue?vue&type=script&lang=js&"
export * from "./iconMsg.vue?vue&type=script&lang=js&"
import style0 from "./iconMsg.vue?vue&type=style&index=0&id=123dd42a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123dd42a",
  null
  
)

export default component.exports